<template>
  <svg
    version="1.1"
    id="Layer_1"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 512 512"
    style="enable-background:new 0 0 512 512;"
    xml:space="preserve"
  >
    <g id="kEgpjS.tif">
      <g>
        <path
          class="st0"
          d="M126.8,83.1c-10.7,10.3-21.1,20.4-31.5,30.6c-6.7,6.7-6.6,9.8,0,16.5c1.3,1.3,2.6,2.6,4,3.9
			c7.1,6.8,9.5,6.9,16.4,0c10.2-10.2,20.4-20.6,29.9-30.2c17.5,17,34.3,33.3,51,49.6c-10,10.2-20,20.4-30.1,30.6
			c-7.4,7.5-7.4,9.7-0.3,16.9c12.1,12.1,12.2,12.2,24.1,0c8.9-8.9,17.6-18.1,26.2-27.1c17.2,17.6,33.6,34.1,50.8,51.4
			c-9.5,9.3-19.6,19.2-29.8,29.2c-8,7.9-7.9,9.9,0.3,18c1.1,1.1,2.3,2.3,3.3,3.3c6.5,6.1,9.1,6.4,15.2,0.1
			c10.3-10.5,20.6-21.2,30.5-31.5c17.5,17.6,33.8,34,51,51.2c-9.7,9.6-19.9,19.6-30.2,29.9c-7.5,7.4-7.4,9.3-0.2,16.8
			c1.6,1.7,3.3,3.3,5,5.1c4.7,5.3,9.3,5,14.1,0c10.5-10.8,21.2-21.2,31.6-31.7c16.7,16.9,33.1,33.3,50.2,50.7
			c-9.3,9.2-19.3,18.9-29.1,28.8c-8.6,8.6-8.6,10.1-0.3,18.5c1.3,1.3,2.7,2.6,3.9,4c4.9,5.6,9.6,5.4,14.8,0.1
			c10.3-10.6,20.9-20.9,33.1-33.1c7,7.7,13.7,15.3,20.8,22.6c7.1,7.4,14.6,14.7,21.9,21.9c10.1,10,14.2,21.7,8.5,35.2
			c-5.7,13.7-16.7,19.8-31.4,19.8c-63.2,0-126.3,0-189.6,0c-66.1,0-132.2,0-198.3,0c-22.2,0-34.9-12.6-34.9-34.8
			c0-129.6,0-259.1-0.1-388.7c0-13.8,5.5-23.9,18-30c13-6.4,25-3.6,35,5.9C96,51.6,110.6,66.9,126.8,83.1z M250.4,370.1
			c-36-36.2-72.1-72.4-108-108.5c0,35.9,0,72.3,0,108.5C179.2,370.1,215.2,370.1,250.4,370.1z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
